import React, { Component } from 'react';
import Office from '../../models/Office';
import OfficeView from '../views/OfficeView';
import OfficesMapView from '../views/OfficesMapView';
import ContentModel from '../../models/ContentModel';

declare var dataLayer: any;

type OfficesOverviewPageProps = {
    offices: Office[];
    content: ContentModel;
}

type OfficesOverviewPageState = {
}

export default class OfficesOverviewPage extends Component<OfficesOverviewPageProps, OfficesOverviewPageState> {
    constructor(props: OfficesOverviewPageProps) {
        super(props);
    }

    public render() {
        return (
            <div className="container mt-5 mb-5">
                <div className="row">
                    <div className="col">
                        <OfficesMapView offices={this.props.offices} translations={{
                            sendMail: this.props.content.sendEmailLabel,
                            routeDescription: this.props.content.travelDirectionsLabel,
                        }}></OfficesMapView>
                    </div>
                </div>
                <div className="row">
                    {
                        this.props.offices.map((office: Office, index: number) => {
                            return (
                                <div className="col-md-6 col-lg-4" key={index}>
                                    <OfficeView office={office} content={this.props.content} ></OfficeView>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}